/**
 * Utility functions for displaying user notifications
 */

/**
 * Show a session expiration notification to the user
 * This creates a temporary modal-style notification that's more user-friendly than alert()
 */
export const showSessionExpiredNotification = () => {
  // Create a styled notification overlay
  const overlay = document.createElement('div');
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  `;

  const notification = document.createElement('div');
  notification.style.cssText = `
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    text-align: center;
  `;

  notification.innerHTML = `
    <div style="margin-bottom: 20px;">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" style="margin: 0 auto;">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>
    <h3 style="margin: 0 0 10px 0; color: #1f2937; font-size: 18px; font-weight: 600;">
      Session Expired
    </h3>
    <p style="margin: 0 0 20px 0; color: #6b7280; font-size: 14px;">
      Your session has expired. Please log in again to continue.
    </p>
    <button id="sessionExpiredBtn" style="
      background: #3b82f6;
      color: white;
      border: none;
      padding: 10px 24px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background 0.2s;
    ">
      OK
    </button>
  `;

  overlay.appendChild(notification);
  document.body.appendChild(overlay);

  // Add hover effect
  const button = notification.querySelector('#sessionExpiredBtn');
  button.addEventListener('mouseenter', () => {
    button.style.background = '#2563eb';
  });
  button.addEventListener('mouseleave', () => {
    button.style.background = '#3b82f6';
  });

  // Return a promise that resolves when user clicks OK
  return new Promise((resolve) => {
    button.addEventListener('click', () => {
      document.body.removeChild(overlay);
      resolve();
    });
  });
};

/**
 * Show a generic error notification
 */
export const showErrorNotification = (message) => {
  const notification = document.createElement('div');
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #ef4444;
    color: white;
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10000;
    max-width: 400px;
    animation: slideIn 0.3s ease-out;
  `;

  notification.textContent = message;
  document.body.appendChild(notification);

  // Auto-remove after 5 seconds
  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease-out';
    setTimeout(() => {
      if (document.body.contains(notification)) {
        document.body.removeChild(notification);
      }
    }, 300);
  }, 5000);
};

// Add CSS animations
if (!document.querySelector('#notification-styles')) {
  const style = document.createElement('style');
  style.id = 'notification-styles';
  style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    @keyframes slideOut {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(400px);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);
}
